import classnames from 'classnames'
import * as React from 'react'

import * as css from './header.css'
import { PropsFromState } from './props'

import { setDevParametersIfNeeded } from '@notes/webintegrations-common'
import { getSignOutUrl } from '@notes/webintegrations-common'
import { LocalizationService } from '../../localization/LocalizationService'
import { Constants } from '../../shared/Constants'

type Props = PropsFromState

/**
 * A header component to be used in dev/staging environments. The O365 shell
 * header replaces this in PROD. Therefore it is not necessary to make this
 * header fully functional, accessible, compliant, etc.
 */
export class Header extends React.PureComponent<Props> {
  render(): JSX.Element {
    const { inMobileDetailView } = this.props
    const signOut = LocalizationService.getLocalizedString('stickyNotes.signOut')
    const redirectUrlWithoutParam = `${Constants.protocolAndHostName}`
    const redirectUrl = setDevParametersIfNeeded(redirectUrlWithoutParam)
    const signOutUrl = getSignOutUrl(redirectUrl)

    return (
      <header id='TopContainer' className={ classnames(css.header, inMobileDetailView ? css.hidden : null) }>
        <div className={ classnames(css.left, css.contentSegment) }>
          <div className={ css.appAndBrandContainer }>
            <div className={ css.wafflebutton }>
              <div className={ css.waffleIcon } />
            </div>
            <span className={ css.title }>TEST HEADER - Sticky Notes - TEST HEADER</span>
          </div>
        </div>
        <div className={ classnames(css.right, css.contentSegment) }>
          <a className={ css.headerLink } href={ signOutUrl }>{ signOut }</a>
        </div>
      </header>
    )
  }
}
